import { useCallback } from 'react'

import { UseHandleRegionChange as UseHandleRegionLocationChange } from '../interfaces'

export const useHandleRegionLocationChange: UseHandleRegionLocationChange = ({ setValues }) => {
  return useCallback(
    (selectedRegionId: number | undefined, selectedLocationId: number | undefined) => {
      setValues((prevValues) => ({
        ...prevValues,
        selectedRegionId: selectedRegionId,
        selectedLocationId: selectedLocationId,
      }))
    },
    [setValues],
  )
}
